const fmt = (n) => (Math.round(+n || 0)).toLocaleString('ru-RU');

export default function TotalsBar({ totals, meta, onChangeNote }) {
  return (
    <div className="card">
      <div className="section-title"><i></i>Итоги</div>
      <div className="kpi">
        <div className="card"><div className="small muted">Материалы</div><div className="value">{fmt(totals?.mat)} ₽</div></div>
        <div className="card"><div className="small muted">Работы</div><div className="value">{fmt(meta?.hideMarkup ? (totals?.work + (totals?.mark || 0)) : totals?.work)} ₽</div></div>
        <div className="card"><div className="small muted">Наценка/орг.</div><div className="value">{meta?.hideMarkup ? 'в работах' : `${fmt(totals?.mark)} ₽`}</div></div>
        <div className="card"><div className="small muted">Итого</div><div className="value">{fmt(totals?.all)} ₽</div></div>
      </div>
      <label style={{ marginTop: 8 }}>Примечание</label>
      <textarea
        value={meta?.note || ''}
        onChange={(e) => onChangeNote?.(e.target.value)}
      />
    </div>
  );
}
